import { render, staticRenderFns } from "./MapLegend.vue?vue&type=template&id=630c0aa3&"
import script from "./MapLegend.vue?vue&type=script&lang=ts&"
export * from "./MapLegend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports